const CATEGORY_IDS = {
  ADMINISTRATIVE_ACT: 'administrative-act',
  CONTRACT_DOCUMENTS: 'contract-documents'
}

export const ATTACHMENT_CATEGORIES = [
  {
    description: 'Archivo obligatorio.',
    id: CATEGORY_IDS.CONTRACT_DOCUMENTS,
    title: 'Documentos del contrato'
  },
  {
    description: 'Archivo obligatorio.',
    id: CATEGORY_IDS.ADMINISTRATIVE_ACT,
    title: 'Acto administrativo aprobatorio'
  }
]

export const ATTACHMENT_CATEGORY_IDS = CATEGORY_IDS

export const FORM_SECTION_IDS = {
  ADMINISTRATIVE_ACT: 'administrative-act',
  ATTACHMENTS: 'attachments',
  GENERAL_INFORMATION: 'general-information',
  JUSTIFICATION: 'justification',
  SUPPLIER_IDENTIFICATION: 'supplier-identification',
  SUSTAINABLE_PURCHASE: 'sustainable-purchase'
}

export const FORM_SECTIONS = [
  {
    description:
      'Selecciona la causal que explica por qué esta compra se realizó fuera de Mercado Público. Este módulo permite registrar únicamente las cinco causales disponibles en esta lista.',
    id: FORM_SECTION_IDS.JUSTIFICATION,
    title: 'Justificación de la compra'
  },
  {
    description: 'Indica los datos del acto administrativo que autoriza esta compra.',
    id: FORM_SECTION_IDS.ADMINISTRATIVE_ACT,
    title: 'Acto administrativo'
  },
  {
    description:
      'Completa la información del proveedor con el que realizaste la compra fuera de Mercado Público.',
    id: FORM_SECTION_IDS.SUPPLIER_IDENTIFICATION,
    title: 'Identificación del proveedor'
  },
  {
    description: 'Ingresa los datos generales de tu contratación.',
    id: FORM_SECTION_IDS.GENERAL_INFORMATION,
    title: 'Información general'
  },
  {
    description:
      'Adjunta documentos que acrediten la realización de la Compra fuera de Mercado Público.',
    id: FORM_SECTION_IDS.ATTACHMENTS,
    title: 'Adjuntos de la compra'
  },
  {
    description:
      'Esta marca no altera el proceso de compra, pero es clave para medir y visibilizar las compras sustentables en el Estado, en línea con los objetivos de la nueva Ley de Compras Públicas.',
    id: FORM_SECTION_IDS.SUSTAINABLE_PURCHASE,
    title: 'Compra sustentable'
  }
]

export const IS_FOREIGN = {
  CAUSAL_VALUE: 4,
  PROCEDURE_VALUE: 3
}

export const MAX_FILES_PER_ATTACHMENT = 2
